import { Button } from '../../../components/ui/button'
import { PexIcon } from '../../../components/icons/PexIcon'
import type { SellerStoresStrings } from '../../../i18n/seller/stores'
import { ProviderMark } from './ProviderMark'
import type { StoreProviderDefinition } from './store-providers'

export function StoreProviderCard({
  provider,
  copy,
  onConnect,
}: {
  provider: StoreProviderDefinition
  copy: SellerStoresStrings
  onConnect: (provider: StoreProviderDefinition) => void
}) {
  const connectable = provider.availability === 'connectable'

  return (
    <article
      className={`group flex min-h-28 items-center gap-4 rounded-xl border bg-white p-4 shadow-[var(--shadow-card)] transition ${
        connectable
          ? 'border-slate-200 hover:-translate-y-0.5 hover:border-indigo-300 hover:shadow-md'
          : 'border-slate-200'
      }`}
    >
      <ProviderMark provider={provider} size="lg" />
      <div className="min-w-0 flex-1">
        <h3 className="text-base font-semibold text-slate-950">{provider.name}</h3>
        <p className="mt-1 line-clamp-2 text-xs leading-5 text-slate-500">
          {copy.providerDescriptions[provider.id]}
        </p>
      </div>
      {connectable ? (
        <Button
          variant="ghost"
          size="sm"
          className="shrink-0 text-indigo-700 hover:bg-indigo-50"
          onClick={() => onConnect(provider)}
        >
          {copy.actions.connect}
          <PexIcon
            name="caretRight"
            size="xs"
            tone="interactive"
            className="ml-1"
          />
        </Button>
      ) : (
        <span className="shrink-0 rounded-full bg-amber-50 px-2.5 py-1 text-[11px] font-semibold text-amber-700 ring-1 ring-amber-200">
          {copy.actions.comingSoon}
        </span>
      )}
    </article>
  )
}
